import { CSSProperties, ReactNode } from "react"
import Toggle, { ToggleProps } from 'react-toggle'
import './styles.css'

type SwitcherTwoProps = Omit<ToggleProps, 'value' | 'checked' | 'defaultChecked' | 'onChange' | 'id' | 'title' | 'style'> & {
  label: ReactNode
  value: boolean
  name: string
  onChange: (target: EventTarget | null | undefined) => void
  title?: string | null
  style?: CSSProperties | null
}

export const SwitcherTwo = ({ label, value, name, onChange, title = null, style = null, ...props }: SwitcherTwoProps) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', ...(style ?? {}) }}>
      <Toggle
        {...props}
        id={name}
        defaultChecked={value}
        checked={value}
        onChange={(e) => onChange(e?.target)}
      />
      <label htmlFor={name} title={title ?? undefined}>{label}</label>
    </div>
  )
}
